// extracted by mini-css-extract-plugin
module.exports = {"shortAddress":"ShortAddress_shortAddress__16h3M","shortAddressLargeText":"ShortAddress_shortAddressLargeText__10Wd3"};